<script setup>
import { useDisplay } from "vuetify";

definePage({
  name: "BaseMobileComms",
  path: "/base/mobile-comms",
  meta: {
    layout: "default",
    requiresAuth: true,
    title: "Comms",
    description: "Join comms, share updates, and stay in sync on Nexus.",
  },
});

const authStore = useAuthStore();
const router = useRouter();
const { mobile } = useDisplay();

const leftValue = ref("0px");
const bottomValue = ref("40px");
const createMomentBtnRef = ref();
const parentCommsBlockRef = ref();

onMounted(async () => {
  if (!mobile.value) {
    router.replace("/base");
  }

  await nextTick();
  updateChildPosition();

  window.addEventListener("resize", updateChildPosition);
  window.addEventListener("scroll", updateChildPosition);
});

const updateChildPosition = () => {
  nextTick(() => {
    const footer = document.querySelector("#footer");
    const btn = createMomentBtnRef.value;
    if (!footer || !btn) return;
    const footerRect = footer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (footerRect.top < windowHeight) {
      const overlap = windowHeight - footerRect.top;
      bottomValue.value = `${overlap + 20}px`;
    } else {
      bottomValue.value = "60px";
    }
    if (parentCommsBlockRef.value) {
      const rect = parentCommsBlockRef.value.getBoundingClientRect();

      if (rect.right && rect.width > 0) {
        leftValue.value = `${rect.right}px`;
      }
    }
  });
};

const reloadComms = async () => {
  commsBlockRef.value.reloadComms();
};

onUnmounted(() => {
  window.removeEventListener("resize", updateChildPosition);
  window.removeEventListener("scroll", updateChildPosition);
});
</script>

<template>
  <!-- StarrySky as fixed background -->
  <StarrySky class="" />

  <!-- Main Content -->
  <div class="tw-page-container tw-min-h-screen tw-relative tw-z-10">
    <v-container>
      <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-[9fr_11fr] tw-gap-4"
      >
        <div
          class="tw-gap-4 tw-relative tw-overflow-hidden"
          ref="parentCommsBlockRef"
        >
          <comms-block ref="commsBlockRef" />
          <create-moment-btn
            ref="createMomentBtnRef"
            class="tw-fixed tw-z-[1]"
            @onCreateMomentSuccess="reloadComms"
            :style="{
              '--left-value': leftValue,
              '--bottom-value': bottomValue,
            }"
          />
        </div>
      </div>
    </v-container>
  </div>
</template>

<style scoped>
.tw-mobile-page-content {
  padding: 16px 0;
}
.tw-page-container {
  background-color: transparent;
}

.btn-create-moment {
  left: calc(var(--left-value) - 72px);
  /* bottom: max(10vh, 70px); */
  bottom: var(--bottom-value);
}
</style>
